import { useState } from "react";
import { KeyRound, Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/common/DetailFields";
import { FounderBadge } from "@/components/red/FounderBadge";
import { useRedEstado } from "@/lib/red";

const Field = ({ label, children }) => <label className="block space-y-1"><span className="text-xs c-text-2">{label}</span>{children}</label>;

const PasswordForm = () => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 10) return toast.error("La nueva contraseña debe tener al menos 10 caracteres");
    if (f.new_password !== f.confirm) return toast.error("Las contraseñas no coinciden");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setF({ current_password: "", new_password: "", confirm: "" });
      toast.success("Contraseña cambiada. Las otras sesiones se cerraron.");
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-2.5 pt-3 border-t c-line" data-testid="password-form">
      <p className="text-sm font-semibold flex items-center gap-1.5"><KeyRound className="w-4 h-4 c-accent" /> Cambiar contraseña</p>
      <Field label="Contraseña actual"><input data-testid="pw-current-input" type="password" autoComplete="current-password" className="c-input" value={f.current_password} onChange={set("current_password")} /></Field>
      <Field label="Nueva contraseña (mín. 8)"><input data-testid="pw-new-input" type="password" autoComplete="new-password" className="c-input" value={f.new_password} onChange={set("new_password")} /></Field>
      <Field label="Confirmar nueva"><input data-testid="pw-confirm-input" type="password" autoComplete="new-password" className="c-input" value={f.confirm} onChange={set("confirm")} /></Field>
      <button data-testid="pw-submit-btn" disabled={busy || !f.current_password} className="c-btn-primary w-full py-3 flex items-center justify-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Cambiar contraseña</button>
    </form>
  );
};

export const ProfileSection = () => {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user.name);
  const [estado] = useRedEstado();
  const save = async () => {
    try { const { data } = await api.patch("/me", { name }); setUser((u) => ({ ...u, name: data.name })); toast.success("Perfil guardado"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Section title="Mi perfil" testid="config-profile" action={<FounderBadge estado={estado} testid="profile-founder-badge" />}>
      <div className="space-y-2.5">
        <p className="text-xs c-muted">Usuario: <span data-testid="profile-username" className="font-mono">{user.username}</span> · {user.role === "dueno" ? "Dueño" : "Asistente"}</p>
        <Field label="Nombre">
          <div className="flex gap-2">
            <input data-testid="profile-name-input" className="c-input flex-1" value={name} onChange={(e) => setName(e.target.value)} />
            <button data-testid="profile-save-btn" disabled={name.trim().length < 2 || name === user.name} onClick={save} className="px-4 rounded-xl c-card disabled:opacity-40" aria-label="Guardar"><Save className="w-4 h-4" /></button>
          </div>
        </Field>
        {user.has_password && <PasswordForm />}
      </div>
    </Section>
  );
};
